import React from 'react';
import { Tag, Typography } from 'antd';

import './RivermeadowTag.scss';

const { Text } = Typography;

export const RivermeadowTag = ({
    children,
    closable = false,
    onClose,
    closeIcon,
    className = '',
    style = {},
    ...rest
}) => {
    return (
        <Tag
            className={`rm-tag ${className}`.trim()}
            closable={closable}
            onClose={onClose}
            closeIcon={closeIcon}
            style={style}
            {...rest}
        >
            <Text ellipsis={{ tooltip: true }}>{children}</Text>
        </Tag>
    );
};
